import { FormField } from 'src/components/molecules/FormField'

import { FormFieldTypes } from 'src/types/form'

import { organisationTypeOptions } from '../../helper'

export const NGOTrust = () => {
  return (
    <FormField
      id='OrgType'
      label='Organisation type'
      options={organisationTypeOptions}
      type={FormFieldTypes.select}
    />
  )
}
